import { shouldShowElaborateMenuItem } from './getShouldShowFunctions/shouldShowElaborateMenuItem';
import { shouldShowPrioritizeMenuItem } from './getShouldShowFunctions/shouldShowPrioritizeMenuItem';
import { getCurrentModule } from 'owa-app-module-store';
import { Module } from 'owa-workloads-module';

/**
 * Helper function that checks whether the minimal Copilot Command Center's menu item
 * should be shown based off of their shouldShow functions to display the placeholder.
 *
 * @param targetWindow - The window in which the command center is being shown.
 */
export function shouldShowMailCommandCenterPlaceholder(targetWindow: Window): boolean {
    return (
        getCurrentModule() === Module.Mail &&
        (shouldShowElaborateMenuItem(false, undefined) ||
            shouldShowPrioritizeMenuItem(false, targetWindow))
    );
}
